import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6493d05a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "ion-margin-vertical" }
const _hoisted_4 = { class: "responsive-table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_6 = { class: "input-cell" }
const _hoisted_7 = { class: "input-cell" }
const _hoisted_8 = { class: "flex-container" }
const _hoisted_9 = { class: "input-cell" }
const _hoisted_10 = { class: "flex-container" }
const _hoisted_11 = { class: "ion-text-center" }
const _hoisted_12 = {
  key: 0,
  class: "new-row"
}
const _hoisted_13 = { class: "input-cell" }
const _hoisted_14 = { class: "input-cell" }
const _hoisted_15 = { class: "flex-container" }
const _hoisted_16 = { class: "input-cell" }
const _hoisted_17 = { class: "flex-container" }
const _hoisted_18 = { class: "ion-text-center" }
const _hoisted_19 = {
  key: 0,
  class: "ion-margin"
}
const _hoisted_20 = { class: "ion-margin-vertical" }
const _hoisted_21 = { class: "summary-card" }
const _hoisted_22 = { class: "flex-container" }
const _hoisted_23 = { class: "flex-container" }
const _hoisted_24 = { class: "flex-container" }
const _hoisted_25 = { class: "flex-container" }
const _hoisted_26 = { class: "ion-text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_import_data_modal = _resolveComponent("import-data-modal")!
  const _component_auto_fill_select = _resolveComponent("auto-fill-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.dataLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ion_spinner),
          _createVNode(_component_ion_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LoadingData')), 1)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_import_data_modal, {
            crop: _ctx.cropId,
            step: "mineral-fertilization",
            onImportData: _ctx.handleImportData
          }, null, 8, ["crop", "onImportData"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", null, [
                _createElementVNode("thead", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Products')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Stade')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('AreaSpread')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityProSpreadHa')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('Cost')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('TotalQuantity')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityNProHa')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityPProHa')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.$t('QuantityKProHa')), 1),
                  _hoisted_5
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cropMineralFertilization.mineral_fertilization_items, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_auto_fill_select, {
                          options: _ctx.productTypes,
                          searchField: "name",
                          selected: item.product_name,
                          label: _ctx.translations[_ctx.currentLanguage].Products,
                          placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                          "onUpdate:modelValue": option => _ctx.handleSelected(option, item, 'product', true)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" >")
                          ]),
                          _: 2
                        }, 1032, ["options", "selected", "label", "placeholder", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_auto_fill_select, {
                          options: _ctx.plantStates,
                          searchField: "name",
                          selected: item.plant_state_name,
                          label: _ctx.translations[_ctx.currentLanguage].PlantState,
                          placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                          "onUpdate:modelValue": option => _ctx.handleSelected(option, item, 'plant_state', true)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" >")
                          ]),
                          _: 2
                        }, 1032, ["options", "selected", "label", "placeholder", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", _hoisted_6, [
                        _createVNode(_component_ion_input, {
                          fill: "solid",
                          type: "number",
                          min: "0",
                          max: "100",
                          modelValue: item.area_spread_percent,
                          "onUpdate:modelValue": ($event: any) => ((item.area_spread_percent) = $event),
                          modelModifiers: { number: true },
                          onIonInput: ($event: any) => (_ctx.estimateTotalQuantity(item)),
                          class: "ion-text-center"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"])
                      ]),
                      _createElementVNode("td", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_ion_input, {
                            fill: "solid",
                            type: "number",
                            min: "0",
                            modelValue: item.quantity_pro_spread_ha,
                            "onUpdate:modelValue": ($event: any) => ((item.quantity_pro_spread_ha) = $event),
                            modelModifiers: { number: true },
                            onIonInput: ($event: any) => (_ctx.estimateTotalQuantity(item)),
                            class: "ion-text-center"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                          _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('UnitKgProHa')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_ion_input, {
                            fill: "solid",
                            type: "number",
                            min: "0",
                            modelValue: item.cost,
                            "onUpdate:modelValue": ($event: any) => ((item.cost) = $event),
                            modelModifiers: { number: true },
                            onIonInput: ($event: any) => (_ctx.handleDebouncedupdateMineralFertiItemData($event, item)),
                            class: "ion-text-center"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onIonInput"]),
                          _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_11, [
                        _createVNode(_component_ion_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.total_quantity) + " " + _toDisplayString(_ctx.$t('UnitKg')), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ion_input, {
                          type: "number",
                          min: "0",
                          modelValue: item.units_n,
                          "onUpdate:modelValue": ($event: any) => ((item.units_n) = $event),
                          modelModifiers: { number: true },
                          readonly: "true",
                          class: "ion-text-center readonly"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ion_input, {
                          type: "number",
                          min: "0",
                          modelValue: item.units_p,
                          "onUpdate:modelValue": ($event: any) => ((item.units_p) = $event),
                          modelModifiers: { number: true },
                          readonly: "true",
                          class: "ion-text-center readonly"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ion_input, {
                          type: "number",
                          min: "0",
                          modelValue: item.units_k,
                          "onUpdate:modelValue": ($event: any) => ((item.units_k) = $event),
                          modelModifiers: { number: true },
                          readonly: "true",
                          class: "ion-text-center readonly"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ion_button, {
                          onClick: ($event: any) => (_ctx.deleteMineralFertiItem(item.id)),
                          color: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128)),
                  (_ctx.newCropMineralFertilizationItem)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_auto_fill_select, {
                            options: _ctx.productTypes,
                            searchField: "name",
                            label: _ctx.translations[_ctx.currentLanguage].Products,
                            placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                            ref: "selectProduct",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = option => _ctx.handleSelected(option, _ctx.newCropMineralFertilizationItem, 'product'))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" >")
                            ]),
                            _: 1
                          }, 8, ["options", "label", "placeholder"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_auto_fill_select, {
                            options: _ctx.plantStates,
                            searchField: "name",
                            label: _ctx.translations[_ctx.currentLanguage].PlantState,
                            placeholder: _ctx.translations[_ctx.currentLanguage].Search,
                            ref: "selectPlantState",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = option => _ctx.handleSelected(option, _ctx.newCropMineralFertilizationItem, 'plant_state'))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" >")
                            ]),
                            _: 1
                          }, 8, ["options", "label", "placeholder"])
                        ]),
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(_component_ion_input, {
                            fill: "solid",
                            type: "number",
                            min: "0",
                            max: "100",
                            modelValue: _ctx.newCropMineralFertilizationItem.area_spread_percent,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newCropMineralFertilizationItem.area_spread_percent) = $event)),
                            modelModifiers: { number: true },
                            onIonInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.estimateTotalQuantity(_ctx.newCropMineralFertilizationItem))),
                            class: "ion-text-center"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_ion_input, {
                              fill: "solid",
                              type: "number",
                              min: "0",
                              modelValue: _ctx.newCropMineralFertilizationItem.quantity_pro_spread_ha,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newCropMineralFertilizationItem.quantity_pro_spread_ha) = $event)),
                              modelModifiers: { number: true },
                              onIonInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.estimateTotalQuantity(_ctx.newCropMineralFertilizationItem))),
                              class: "ion-text-center"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitKgProHa')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_ion_input, {
                              fill: "solid",
                              type: "number",
                              min: "0",
                              modelValue: _ctx.newCropMineralFertilizationItem.cost,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newCropMineralFertilizationItem.cost) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-center"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProT')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_18, [
                          _createVNode(_component_ion_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.newCropMineralFertilizationItem.total_quantity) + " " + _toDisplayString(_ctx.$t('UnitKg')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_input, {
                            type: "number",
                            min: "0",
                            modelValue: _ctx.newCropMineralFertilizationItem.units_n,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newCropMineralFertilizationItem.units_n) = $event)),
                            modelModifiers: { number: true },
                            readonly: "true",
                            class: "ion-text-center readonly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_input, {
                            type: "number",
                            min: "0",
                            modelValue: _ctx.newCropMineralFertilizationItem.units_p,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newCropMineralFertilizationItem.units_p) = $event)),
                            modelModifiers: { number: true },
                            readonly: "true",
                            class: "ion-text-center readonly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_input, {
                            type: "number",
                            min: "0",
                            modelValue: _ctx.newCropMineralFertilizationItem.units_k,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newCropMineralFertilizationItem.units_k) = $event)),
                            modelModifiers: { number: true },
                            readonly: "true",
                            class: "ion-text-center readonly"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_ion_button, { onClick: _ctx.addMineralFertiItem }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.addCircleOutline }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_ion_text, { color: "danger" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_ion_grid, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "auto",
                      class: "flex-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              label: _ctx.translations[_ctx.currentLanguage].TotalUnitsN,
                              readonly: "true",
                              modelValue: _ctx.cropMineralFertilization.units_n,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cropMineralFertilization.units_n) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-right readonly"
                            }, null, 8, ["label", "modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              label: _ctx.translations[_ctx.currentLanguage].TotalUnitsP,
                              readonly: "true",
                              modelValue: _ctx.cropMineralFertilization.units_p,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.cropMineralFertilization.units_p) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-right readonly"
                            }, null, 8, ["label", "modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              label: _ctx.translations[_ctx.currentLanguage].TotalUnitsK,
                              readonly: "true",
                              modelValue: _ctx.cropMineralFertilization.units_k,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.cropMineralFertilization.units_k) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-right readonly"
                            }, null, 8, ["label", "modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitProHa')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_ion_input, {
                              type: "number",
                              label: _ctx.translations[_ctx.currentLanguage].CostMineralFertilizer,
                              readonly: "true",
                              modelValue: _ctx.cropMineralFertilization.cost,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.cropMineralFertilization.cost) = $event)),
                              modelModifiers: { number: true },
                              class: "ion-text-right readonly"
                            }, null, 8, ["label", "modelValue"]),
                            _createVNode(_component_ion_text, { class: "ion-text-nowrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('UnitEuroProHa')), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_ion_button, {
              color: "secondary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.previousStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Previous')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              color: "primary",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.nextStep($event, _ctx.cropSeed)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Next')), 1)
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}